import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

export class TabsSectionOptions extends LayoutRenderLayoutItemOptions {
	tabActionButtons?: boolean;

	constructor() {
		super();
		this.tabActionButtons = false;
	}
}

export enum TabSectionMode {
	TAB,
	BUTTON,
	DROPDOWN
}
